import { fileAPIDgshp } from "./fileAPI.js";
import { commonAPI } from "./commonAPI.js";
import { investorsAPI } from "./investorsAPI.js";
import { newsAPI } from "./newsAPI.js";
import { startupAPI } from "./startupAPI.js";
import { instoreAPI } from "./instoreAPI.js";
import { inquiryAPI } from "./inquiryAPI.js";
import { brandAPI } from "./brandAPI.js";
import { gisAPI } from "./gisAPI.js"
import { gs25ListAPI } from "./gs25ListAPI.js"

const APIDFN = {
    APIDFN: (APIModule, APIName, conditions) => {
        return API[APIModule](APIName, conditions);
    }
};

// eslint-disable-next-line
const API = Object.assign({}
    , { fileAPIDgshp: fileAPIDgshp }
    , { commonAPI: commonAPI }
    , { investorsAPI: investorsAPI }
    , { newsAPI: newsAPI }
    , { startupAPI: startupAPI }
    , { instoreAPI: instoreAPI }
    , { inquiryAPI: inquiryAPI }
    , { brandAPI: brandAPI }
    , { gisAPI: gisAPI}
    , { gs25ListAPI: gs25ListAPI });

export { API, APIDFN };
